import { gql, useQuery } from '@apollo/client';
import { backendNameToLabel } from '../../../utils/formatting';

export const GET_PRODUCT_FACTORABLE_FIELDS = gql`
  query ProductFactorableFields($id: ID!) {
    product(id: $id) {
      id
      insuranceType {
        id
        type
        requireVehicle
      }
      factorableFields
    }
  }
`;

export default function useProductFactorableFields({ productId }) {
  const { data, loading, error } = useQuery(GET_PRODUCT_FACTORABLE_FIELDS, {
    variables: { id: productId }
  });

  const startingOptions = {
    paramOptions:
      data?.product?.factorableFields?.coverage_parameters?.map(value => ({
        label: backendNameToLabel(value),
        value
      })) || [],
    vehicleOptions:
      data?.product?.factorableFields?.vehicle_fields?.map(value => ({ label: backendNameToLabel(value), value })) ||
      [],
    apiOptions:
      data?.product?.factorableFields?.api?.map(value => ({
        label: backendNameToLabel(value)?.replace("Api ", ""),
        value
      })) || []
  };

  const options =
    data?.product?.insuranceType?.requireVehicle === true
      ? [
          { label: 'COVERAGE PARAMETERS', options: startingOptions?.paramOptions },
          { label: 'FACTORABLE VALUES', options: startingOptions?.vehicleOptions },
          { label: 'API OPTIONS', options: startingOptions?.apiOptions }
        ]
      : [
          { label: 'COVERAGE PARAMETERS', options: startingOptions?.paramOptions },
          { label: 'API OPTIONS', options: startingOptions?.apiOptions }
        ];

  const flattenedOptions = [
    {
      label: 'Coverage Parameter Based',
      value: 'coverageParameterBased',
      options: startingOptions?.paramOptions
    },
    {
      label: 'Usage Based (requires values to generate invoice)',
      value: 'usageBased',
      options: startingOptions?.apiOptions
    }
  ];

  if (data?.product?.insuranceType?.requireVehicle === true)
    flattenedOptions.push({
      label: 'Vehicle Options',
      value: 'vehicleOptions',
      options: startingOptions?.vehicleOptions
    });

  return {
    options,
    flattenedOptions,
    loading,
    error
  };
}
